import { Modal } from 'antd';
import { SupportEmailField } from '../SupportEmailField/SupportEmailField';

type Props = {
  open: boolean;
  onClose: () => void;
};

// Lean first version of bug reports and feature requests (#1632): no form, just the
// support address to copy.
export const FeedbackModal = ({ open, onClose }: Props) => {
  return (
    <Modal
      title={<div className="text-brand-grey-dark text-base font-semibold">Report a bug or share your feedback</div>}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={640}
      // index.scss pins every .ant-modal-content to 16px 12px with !important; the
      // design wants 32px sides and top. Same override the AI modals use.
      className="[&_.ant-modal-content]:!px-8 [&_.ant-modal-content]:!pt-8 [&_.ant-modal-content]:!pb-6"
    >
      <div className="flex flex-col gap-5 pt-6 text-brand-grey-dark text-sm font-normal leading-5">
        <p className="m-0">
          Found something that isn’t working as expected, or have an idea to improve Taskonio?
          <br />
          Email us, we’d love to hear from you! 🙏
        </p>
        <p className="m-0">
          If you’re reporting a bug, tell us what happened, what you expected, and how we can reproduce it. Screenshots
          are helpful too.
        </p>
        <p className="m-0">From the Taskonio team, thanks for helping us make Taskonio better. ❤️</p>
      </div>

      <SupportEmailField size="large" className="mt-10" />
    </Modal>
  );
};
